import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiHelper} from '../../../../../services/api.helper';
import {Observable} from 'rxjs';
import {CustomPostTypeEnum} from '../../../../../enums/WPEnums';
import {catchError} from 'rxjs/operators';
import {WPPostCareServiceTypePage} from '../typings/WPPostCareServiceTypePage';
import {WPPostSymptomPage} from '../typings/WPPostSymptomPage';
import {AppConfigService} from '../../../../../services/app-config.service';
import {DOCUMENT} from '@angular/common';
import {ToolsService} from '../../../../../services/tools.service';

@Injectable()
export class SearchContentDataV2Service {
  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private tools: ToolsService,
    private appConfigService: AppConfigService,
    @Inject(DOCUMENT) private doc: any,
  ) {}

  public GetCareServicePostBySlug(slug: string, isPreview?: boolean): Observable<Array<WPPostCareServiceTypePage>> {
    const apiUrl: string = this.appConfigService.appConfig.wordpressApiUrl;
    const endpoint: string = apiUrl + `${CustomPostTypeEnum.SERVICE_TYPE_PAGE}?slug=${slug}`;

    return this.http
      .get<Array<WPPostCareServiceTypePage>>(endpoint)
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public GetSymptomPostBySlug(slug: string, isPreview?: boolean): Observable<Array<WPPostSymptomPage>> {
    const apiUrl: string = this.appConfigService.appConfig.wordpressApiUrl;
    const endpoint: string = apiUrl + `${CustomPostTypeEnum.SYMPTOM_PAGE}?slug=${slug}`;

    return this.http
      .get<Array<WPPostSymptomPage>>(endpoint)
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }
}
